import React from "react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Users, ArrowRight } from "lucide-react";

const SellerBannerSection = ({ variants }) => {
  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  return (
    <motion.section
      className="py-12 md:py-16 bg-gradient-to-r from-accent to-primary/80 text-primary-foreground"
      variants={variants || itemVariants}
      initial="hidden"
      animate="visible"
      viewport={{ once: true, amount: 0.3 }}
    >
      <div className="container mx-auto px-4 text-center">
        <motion.div variants={itemVariants}>
          <Users className="h-12 w-12 text-background mx-auto mb-4" />
          <h2 className="text-3xl sm:text-4xl font-bold mb-4 text-background">
            Are You a Parts Seller?
          </h2>
        </motion.div>
        <motion.p
          className="text-base sm:text-lg text-background/90 mb-8 max-w-3xl mx-auto"
          variants={itemVariants}
        >
          Join Parts Lokator today and connect with buyers looking for parts
          like yours! Create your free profile, upload your inventory, and let
          Kato — our AI assistant — help match your parts with real-time demand.
          Start selling now and grow your business!
        </motion.p>
        <motion.div variants={itemVariants}>
          <Button
            asChild
            className="bg-background text-primary hover:bg-background/90 shadow-lg group transition-all duration-300 ease-in-out transform hover:scale-105 h-auto sm:h-14 rounded-lg px-10 text-lg"
          >
            <Link to="/list-inventory">
              Start Selling Now
              <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
            </Link>
          </Button>
        </motion.div>
      </div>
    </motion.section>
  );
};

export default SellerBannerSection;
